(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plawny-cart-guard"] && !Shopify.designMode) return;
  try {
    
(() => {
  const cartDeliveryPath = '/cart#dostawa';
  const focusDeliveryPicker = () => {
    const picker = document.querySelector('#dostawa');
    if (!picker) return false;
    const target = picker.querySelector('.delivery-picker__methods') || picker;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    picker.classList.add('delivery-picker--attention');
    window.setTimeout(() => picker.classList.remove('delivery-picker--attention'), 1400);
    return true;
  };
  const isCheckoutTrigger = (element) => {
    if (!element) return false;
    const name = element.getAttribute('name') || '';
    const href = element.getAttribute('href') || '';
    const text = (element.textContent || element.value || '').toLowerCase();
    return name === 'checkout' || href.startsWith('/checkout') || text.includes('zrealizuj zakup');
  };
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('button,input,a,[role="button"]');
    if (!isCheckoutTrigger(trigger)) return;
    event.preventDefault();
    event.stopPropagation();
    if (!focusDeliveryPicker()) {
      window.location.assign(cartDeliveryPath);
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const form = event.target;
    const checkout = form.querySelector('button[name="checkout"],input[name="checkout"],a[href^="/checkout"]');
    if (!checkout) return;
    event.preventDefault();
    if (!focusDeliveryPicker()) window.location.assign(cartDeliveryPath);
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plawny-product-v2"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-pv2-product]').forEach((root)=>{const dialog=root.querySelector('[data-pv2-size-dialog]');root.querySelector('[data-pv2-size-open]')?.addEventListener('click',()=>dialog?.showModal());const variants=JSON.parse(root.dataset.variants||'[]');const add=root.querySelector('[data-pv2-add]');root.querySelectorAll('input[name="id"]').forEach((input)=>{input.addEventListener('change',()=>{const variant=variants.find((item)=>String(item.id)===input.value);if(!variant||!add)return;add.disabled=!variant.available})})});

  } catch(e) { console.error(e); }
})();
})();
